import { render, staticRenderFns } from "./DeletedTabSidebar.vue?vue&type=template&id=bf550492&scoped=true"
import script from "./DeletedTabSidebar.vue?vue&type=script&lang=js"
export * from "./DeletedTabSidebar.vue?vue&type=script&lang=js"
import style0 from "./DeletedTabSidebar.vue?vue&type=style&index=0&id=bf550492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf550492",
  null
  
)

export default component.exports